import {Windows95Window} from "../Windows95Window";
import {BLEND_MODES, Container, Graphics, NineSlicePlane, Sprite, Text, TextStyle, Texture, TilingSprite} from "pixi.js";
import {buttonify} from "../../../engine/HelperFunctions/buttonify";
import {GAME_FONT, GAME_FONT_BOLD} from "../../Constants/Constants";
import { GameObject, HelperFunctions } from "../../../tsthree";
import {Department, DepartmentToString, IntegerToDepartment} from "../../Types/Department";
import {IMedCaseJSON} from "../../Types/IMedCaseJSON";
import {uppercaseFirstLettersInString} from "../../../engine/HelperFunctions/uppercaseFirstLettersInString";
import { IWindowState } from "../../Types/IWindowState";
import { GAME_DEBUG_MODE } from "../../../engine/Constants/Constants";
import { getCaseAmountsFromXP, SelectACaseUnlocks } from "../../Data/SelectACaseUnlocks";
import { DoctorRanks } from "../../Constants/DoctorRanks";
import { PlayerDataSingleton } from "../../Logic/PlayerDataSingleton";
import { TutorialStageComponent } from "../../Components/TutorialStageComponent";
import { ShowBluescreen } from "../../Logic/ShowBluescreen";
import { Easing } from "@tweenjs/tween.js";
import { ScaleElementOnClickComponent } from "../../../engine/Components/ScaleElementOnClickComponent";
import { createPatientPictureFromPatientName } from "../../Logic/createPatientPictureFromPatientName";
import { HospitalNetCore } from "../../Logic/HospitalNetCore";

export class Win95CaseSelectionWindow extends Windows95Window {

    private static _width = 600;
    private static _height = 370;

    // private _isFetching: boolean = false;
    private _departmentIconSwitchTimer = 0;
    // private _departmentIcons: Array<Sprite> = [];
    private _loadingIcons: Array<Sprite> = [];

    // private _texts: Text[] = [];
    // private _generatedText: Text;
    // private _randomText: Text;
    // private _icons: Sprite[] = [];
    // private _generatedDepartmentIcon: Sprite;
    // private _randomDepartmentIcon: Sprite;
    private _caseElements: Array<{
        container: GameObject,
        text: Text,
        icon: Sprite,
        bg: NineSlicePlane,
        deptBg: NineSlicePlane,
        overlay: Container,
        unlockedAtText: Text,
    }> = [];

    private _cases: IMedCaseJSON[];
    // private _generatedCase: IMedCaseJSON;
    // private _randomCase: IMedCaseJSON;

    private _onSelectCase: (e: IMedCaseJSON | null) => void;

    private createCaseContainer(): {
        container: GameObject,
        text: Text,
        icon: Sprite,
        bg: NineSlicePlane,
        deptBg: NineSlicePlane,
        overlay: Container,
        unlockedAtText: Text,
    }
    {
        const generatedCaseContainer = new GameObject();
        generatedCaseContainer.addComponent(new TutorialStageComponent({
            id: "SelectACaseStage2"
        }));
        generatedCaseContainer.addComponent(new ScaleElementOnClickComponent(0.95));

        const generatedCaseBg = new NineSlicePlane(
            ENGINE.getPIXIResource("button") as Texture
        );
        generatedCaseBg.width = 240;
        generatedCaseBg.height = 200;
        generatedCaseContainer.addChild(generatedCaseBg);

        const generatedCaseDepartmentBg = new NineSlicePlane(
            ENGINE.getPIXIResource("inner-container-nineslice") as Texture
        );
        generatedCaseDepartmentBg.width = 110;
        generatedCaseDepartmentBg.height = 110;
        generatedCaseDepartmentBg.position.set(
            -(generatedCaseDepartmentBg.width / 2) + (generatedCaseBg.width / 2),
            -(generatedCaseDepartmentBg.height / 2) + (generatedCaseDepartmentBg.height / 2) + 4
        );
        generatedCaseContainer.addChild(generatedCaseDepartmentBg);

        const departmentIconMask = new Graphics();
        departmentIconMask.beginFill(0xff0000, 1);
        departmentIconMask.drawRect(2, 2,
            generatedCaseDepartmentBg.width - 4,
            generatedCaseDepartmentBg.height - 4
        );
        departmentIconMask.endFill();
        const departmentIcon = new Sprite(Texture.EMPTY);
        departmentIcon.position.set(2, 2);
        departmentIcon.mask = departmentIconMask;
        generatedCaseDepartmentBg.addChild(departmentIconMask);
        // HelperFunctions.smartScale2D({
        //         x: 106,
        //         y: 106
        //     },
        //     departmentIcon
        // );
        // this._departmentIcons.push(departmentIcon);
        generatedCaseDepartmentBg.addChild(departmentIcon);

        const generatedCaseFieldsText = new Text(`Name:
Difficulty:
Department:
Number of symptoms:
Can communicate:`,
            new TextStyle({
                fill: 0x000000,
                fontFamily: GAME_FONT_BOLD,
                fontSize: 11,
                align: "left",
            })
        );
        generatedCaseFieldsText.anchor.set(0, 0);
        generatedCaseFieldsText.position.set(
            25,
            generatedCaseDepartmentBg.y + (generatedCaseDepartmentBg.height) + 8,
        );
        generatedCaseContainer.addChild(generatedCaseFieldsText);

        const generatedCaseText = new Text(`...
...
...
...
...`,
            new TextStyle({
                fill: 0x000000,
                fontFamily: GAME_FONT,
                fontSize: 11,
                align: "right",
            })
        );
        generatedCaseText.anchor.set(1, 0);
        generatedCaseText.position.set(
            -25 + (generatedCaseBg.width),
            generatedCaseDepartmentBg.y + (generatedCaseDepartmentBg.height) + 8,
        );
        generatedCaseContainer.addChild(generatedCaseText);

        const generatedCaseLoadingIcon = new Sprite(ENGINE.getPIXIResource("loadingicon") as Texture);
        generatedCaseLoadingIcon.anchor.set(0.5, 0.5);
        generatedCaseLoadingIcon.position.set(
            generatedCaseBg.width / 2,
            150
        );
        this._loadingIcons.push(generatedCaseLoadingIcon);
        generatedCaseContainer.addChild(generatedCaseLoadingIcon);

        const overlayContainer = new Container();
        const overlayBlack = new Graphics();
        overlayBlack.beginFill(0x000000, 0.55);
        overlayBlack.drawRect(0, 0, generatedCaseBg.width, generatedCaseBg.height);
        overlayBlack.endFill();
        overlayBlack.blendMode = BLEND_MODES.MULTIPLY;
        overlayContainer.addChild(overlayBlack);
        // const overlay = new TilingSprite(
        //     ENGINE.getPIXIResource("checkerboard-nineslice") as Texture,
        //     generatedCaseBg.width,
        //     generatedCaseBg.height,
        // );
        // overlay.alpha = 1;
        // overlay.blendMode = BLEND_MODES.MULTIPLY;
        // overlayContainer.addChild(overlay);
        generatedCaseContainer.addChild(overlayContainer);

        const unlockedAtText: Text = new Text("Unlocked at:\n", new TextStyle({
            fontSize: 18,
            fill: 0xffffff,
            fontFamily: GAME_FONT_BOLD,
            align: "center"
        }));
        unlockedAtText.anchor.set(0.5);
        unlockedAtText.position.set(
            120,
        );
        generatedCaseContainer.addChild(unlockedAtText);


        return {
            container: generatedCaseContainer,
            text: generatedCaseText,
            icon: departmentIcon,
            bg: generatedCaseBg,
            deptBg: generatedCaseDepartmentBg,
            overlay: overlayContainer,
            unlockedAtText: unlockedAtText,
        };
    }

    constructor(_settings: {
        onMinimise: () => void;
        onClose: () => void;
        windowStateRef: IWindowState<Win95CaseSelectionWindow>;
    }) {
        super({
            onClose: () => {
                if(this.getComponent(TutorialStageComponent)?.isActive) return;
                this._onSelectCase?.(null);
                _settings.onClose();
            },
            onMinimise: () => {
                if(this.getComponent(TutorialStageComponent)?.isActive) return;
                _settings.onMinimise();
            },
            iconKey: "doctorstats-icon-alt",
            title: "Select-A-Case - DoctOS",
            windowStateRef: _settings.windowStateRef,
            dimensions: {
                width: Win95CaseSelectionWindow._width,
                height: Win95CaseSelectionWindow._height
            }
        });

        const explanationTextLineOne = new Text(
            `You may select one of these cases. The more stars a case has, the more difficult it will be to solve.`,
            new TextStyle({
                align: "center",
                // wordWrapWidth: Win95CaseSelectionWindow._width * 2,
                // wordWrap: true,
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0x000000
            })
        );
        explanationTextLineOne.anchor.set(0.5, 0.5);
        explanationTextLineOne.position.set(Win95CaseSelectionWindow._width / 2, 35);
        this.contentContainer.addChild(explanationTextLineOne);

        const explanationTextLineTwo = new Text(
            `Don't forget: you can have any amount of open cases at once, so take as many as you can handle!`,
            new TextStyle({
                align: "center",
                fontFamily: GAME_FONT,
                fontSize: 11,
                fill: 0x000000
            }));
        explanationTextLineTwo.anchor.set(0.5, 0.5);
        explanationTextLineTwo.position.set(Win95CaseSelectionWindow._width / 2, 49);
        this.contentContainer.addChild(explanationTextLineTwo);

        const refreshButtonGO = new GameObject();
        refreshButtonGO.position.set(
            (Win95CaseSelectionWindow._width * 0.5) - (200 * 0.5),
            67,
        );
        const refreshButtonBg = new NineSlicePlane(ENGINE.getPIXIResource("button") as Texture);
        refreshButtonBg.width = 200;
        refreshButtonBg.height = 40;
        refreshButtonBg.position.set(
            0,
            0,
        );
        refreshButtonGO.addChild(refreshButtonBg);
        const refreshButtonText = new Text("Refresh selection", {
            fontSize: 16,
            fontWeight: "bold",
            fontFamily: GAME_FONT_BOLD
        });
        refreshButtonText.anchor.set(0.5, 0.5);
        refreshButtonText.position.set(
            (refreshButtonBg.width * 0.5) + 10,
            refreshButtonBg.height * 0.5,
        );
        refreshButtonBg.addChild(refreshButtonText);
        const refreshButtonIcon = new Sprite(
            ENGINE.getTexture("refresh-icon")
        );
        refreshButtonIcon.anchor.set(0.5, 0.5);
        refreshButtonIcon.scale.set(0.66, 0.66);
        refreshButtonIcon.position.set(
            refreshButtonText.x + (refreshButtonText.width * -refreshButtonText.anchor.x) - 5 - (refreshButtonIcon.width * 0.5),
            (refreshButtonBg.height * 0.5)
        );
        refreshButtonBg.addChild(refreshButtonIcon);

        let antiSpam = false;
        buttonify(refreshButtonBg, {
            onFire: () => {
                if(antiSpam) return;
                antiSpam = true;

                const _cases: Array<Partial<IMedCaseJSON>> = [];
                // const hospitalCore = ENGINE.getWASM<{
                //     generateCase: (_settings: {
                //         filters: {
                //             departmentFilter: Department[]
                //         }
                //     }) => string
                // }>("HospitalCore");
                HospitalNetCore
                    .generateCases(getCaseAmountsFromXP(
                        PlayerDataSingleton.getDocScore()
                    ))
                    .forEach((e) => {
                        _cases.push(
                            e
                        );
                    });
                this.update(
                    _cases as IMedCaseJSON[],
                    PlayerDataSingleton.getDocScore(),
                    this._onSelectCase
                );

                HelperFunctions.TWEENAsPromise(
                    refreshButtonIcon,
                    "rotation",
                    Math.PI * 2,
                    Easing.Linear.None,
                    300
                ).promise.then(() => {
                    refreshButtonIcon.rotation = 0;
                    antiSpam = false;
                });
            }
        });
        this.contentContainer.addChild(refreshButtonGO);
        refreshButtonGO.addComponent(new ScaleElementOnClickComponent(0.95));

        for(let i = 0; i < 2; i++) {
            const generatedCaseContainer = this.createCaseContainer();
            generatedCaseContainer.container.position.set(
                ((i % 2) * generatedCaseContainer.bg.width) -
                (generatedCaseContainer.bg.width) +
                300 +
                (8 * (((i % 2) * 2) - 1)),

                (Math.floor(i / 2) * generatedCaseContainer.bg.height) -
                (generatedCaseContainer.bg.height / 2) +
                220 +
                (8 * Math.floor(i / 2))
            );
            this._caseElements.push(generatedCaseContainer);
            this.contentContainer.addChild(generatedCaseContainer.container);
        }
        // GENERATED CASE
        // const generatedCaseContainer = this.createCaseContainer();
        // generatedCaseContainer.container.position.set(
        //     8,
        //     80
        // );
        // this._caseElements.push(generatedCaseContainer);
        // this.contentContainer.addChild(generatedCaseContainer.container);
        //
        // // RANDOM CASE
        // const randomCaseContainer = this.createCaseContainer();
        // randomCaseContainer.container.position.set(
        //     8 + generatedCaseContainer.container.width + 2,
        //     80
        // );
        // this._caseElements.push(randomCaseContainer);
        // this.contentContainer.addChild(randomCaseContainer.container);

        // interactives
        buttonify(this._caseElements.map((e) => e.container), {
            onFire: (ev, i) => {
                try {
                    if(this.getComponent(TutorialStageComponent)?.isActive) return;
                    const ind = this._caseElements.findIndex((e) => e.container === ev.target);
                    this._onSelectCase(this._cases[ind]);
                } catch(err) {
                    ShowBluescreen(err.stack);
                }
            }
        });
    }

    private createStringFromCaseJSON(_case: IMedCaseJSON): string {
        return `${
            !_case ? "..." : uppercaseFirstLettersInString(_case.patientName)
        }\n${
            !_case ? "..." : "★".repeat(Math.round(_case.difficultyScore))
        }\n${
            !_case ? "..." : DepartmentToString[_case.department]
        }\n${
            !_case ? "..." : _case.currentSymptoms.length
        }\n${
            !_case ? "..." : HospitalNetCore.canPatientSpeak(_case) ? "Yes" : "No"
        }`;
    }

    public update(
        _cases: IMedCaseJSON[] | undefined,
        _xp: number,
        _onSelectCase: (_selectedCaseJSON: IMedCaseJSON | null) => void | undefined,
    ) {
        // name
        // department
        // symptoms.length
        if(GAME_DEBUG_MODE) {
            console.log("Updating case selection window with: %o", _cases);
        }
        const cases = _cases || this._cases;
        this._caseElements.forEach((e, i) => {
            const _case = cases[i];
            if(!_case) {
                e.icon.texture =
                    null;
                e.overlay.visible = true;
                const rank = SelectACaseUnlocks[i];
                e.unlockedAtText.visible = true;
                if(rank && _xp < DoctorRanks[rank].threshold) {
                    e.unlockedAtText.text = `Unlocked at:\n\n${DoctorRanks[rank].name}\n${DoctorRanks[rank].threshold} XP`;
                } else {
                    e.unlockedAtText.text = "Unavailable";
                }
                e.icon.position.set(2, 2);
            } else {
                e.unlockedAtText.visible = false;
                e.overlay.visible = false;
                if(e.icon) {
                    e.icon.texture.destroy(true);
                }
                e.icon.texture =
                    createPatientPictureFromPatientName(_case.patientName);
                HelperFunctions.smartScale2D({
                        x: 128,
                        y: 128
                    },
                    e.icon
                );
                e.icon.position.set(
                    (e.icon.width * -0.5) + (e.deptBg.width * 0.5),
                    (e.icon.height * -0.5)+ (e.deptBg.height * 0.5) - 0
                );
            }
            e.text.text = this.createStringFromCaseJSON(_case);
        });

        this._loadingIcons.forEach((e) => e.visible = false);

        this._cases = cases;
        this._onSelectCase = _onSelectCase || this._onSelectCase;
    }

    public reset(): void {
        this._loadingIcons.forEach((e) => {
            e.visible = true;
        });
        this._caseElements.forEach((e, i) => {
            e.text.text = "";
        });
        this._cases = null;
        this._onSelectCase = null;
    }

    onStep(_dt: number) {
        super.onStep(_dt);
    }

}